/**
 * Homepage API Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders Homepgae APIs Section
 */
import React, { useEffect, useState } from 'react';
import { SVBTypography } from '@svb/svb-react-components';
// import Loading from '@svb/api-loading-component/dist/components/index';
// import { Utils } from '@svb/api-content-component';
import { buildCardJsonForAPis } from '../../helpers/utilityFunctions';
import { SVBAPIsSection } from '@svb/portal-ui-react-components';
import useFilteredCatalogLatestVersion from '../../helpers/utilityCustomHooks/useFilteredCatalogLatestVersion';

/**
 * HomepageAPI
 * @param content: url of the API Section content
 * @param title: title of this API section
 * @returns HomepageAPI section with card carousel
 */

const HomepageAPI = ({ datatestid, testMockContent, ...props }) => {
  const { ourapiSectionTitle } = props;
  const [mounted, setMounted] = useState(false);
  const [ourapiSectionLabelState, setOurapiSectionLabelState] = useState('Our APIs');
  const filteredCatalogLatestVersion = useFilteredCatalogLatestVersion();
  const getHomepageAPiSectionContent = datatestid
    ? testMockContent
    : buildCardJsonForAPis(filteredCatalogLatestVersion);

  useEffect(() => {
    if (ourapiSectionTitle) {
      setOurapiSectionLabelState(ourapiSectionTitle);
    }
    setMounted(true);
  }, []);
  // console.log(getHomepageAPiSectionContent);
  const LearnMoreCardLabel = () => (
    <span className='learn-more-label'>
      {'Learn More'}
      <i className='fa-solid fa-arrow-right right-arrow-icon' />
    </span>
  );
  const apiCardsData = {
    apiSectionlabel: '', //title for molecule
    apisJson: getHomepageAPiSectionContent.response, //json from service
    cardsOption: {
      //options for API cards section
      cardOptions: {
        //options for card
        cardBootstrapImage: false,
        cardClickable: false,
        titleSeparator: true,
        externalLink: false,
        overrideLearnMoreElement: LearnMoreCardLabel(),
      },
      extraClasses: '',
      carousel: true,
      cardSlide: 3,
      viewAll: true,
      viewAllLink: '',
    },
    extraClasses: '',
  };

  return !mounted ? (
    <></>
  ) : (
    <section id='homepage-apis' className='apis-section' data-testid='loading-component'>
      <div className='container svb-container-fixed col-md-9 col-sm-12'>
        <div className='row'>
          <div>
            <SVBTypography type='heading-large' variant='header-2'>
              {ourapiSectionLabelState}
            </SVBTypography>
            <div className='homepage_hero__Subseparation'></div>
          </div>
        </div>
        {getHomepageAPiSectionContent.response.length > 0 && (
          <SVBAPIsSection apiCardsData={apiCardsData} />
        )}
      </div>
    </section>
  );
};

export default HomepageAPI;
